import { createReducer } from '@reduxjs/toolkit'

import { updateInvoiceFiatAction } from '../../../actions'

type State = {
  loading: boolean
}

const initialState: State = {
  loading: false
}

export const update = createReducer(initialState, (builder) => {
  builder
    .addCase(updateInvoiceFiatAction.pending, (state) => {
      state.loading = true
    })
    .addCase(updateInvoiceFiatAction.rejected, (state) => {
      state.loading = false
    })
    .addCase(updateInvoiceFiatAction.fulfilled, (state) => {
      state.loading = false
    })
})
